export default __webpack_public_path__ + "static/media/bannerNew2.cf2c384c.jpg";